import { onMounted, type Ref } from 'vue'

export function useWbInputAutofocus (input: Ref) {
  onMounted(() => {
    input.value.$el.querySelector('input')?.focus()
  })
}
